import axios from 'utils/bsac-api.js';
import conversions from 'utils/conversions.js';
import environments from 'constant/environments.js';
import selections from 'constant/selections.js';

const state = {
  productCategories: [],
};

const getters = {
  /**
   * 商品カテゴリを取得する
   * @param {*} state
   * @returns
   */
  productCategories: (state) => state.productCategories,
  /**
   * セレクトボックス用商品カテゴリを取得する
   * @param {*} state
   * @returns
   */
  productCategoriesForSelectBox: (state) => {
    let categories = [];
    categories.push({ id: selections.notSelected, nameJa: '全て' });
    state.productCategories.forEach((category) => categories.push(category));
    return categories;
  },
};

const mutations = {
  /**
   * 商品カテゴリーをセットする
   * @param {*} state
   * @param {*} categories
   */
  setProductCategories(state, categories) {
    state.productCategories = [];
    categories.forEach(function (category) {
      state.productCategories.push(conversions.toCamelCaseForObject(category));
    });
  },
};

const actions = {
  /**
   * APIを呼び出し商品カテゴリ一覧を取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getProductCategories({ commit, rootGetters }) {
    const headers = rootGetters['partner/authHeaders']
      ? { headers: rootGetters['partner/authHeaders'] }
      : null;
    // console.log(`header: ${JSON.stringify(headers)}`);
    return axios
      .get(`${environments.shoppingApiUrl}/product_categories`, headers)
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        commit('setProductCategories', response.data.data);
        return {
          success: true,
        };
      })
      .catch((error) => {
        console.error(error.response);
        return {
          success: false,
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
